<template>
  <div
    class="relative cursor-pointer w-full text-center transition-colors duration-150"
    :class="{
      'text-white': bright && active,
      'text-gray-500': bright && !active,
      'bg-gray-200 text-gray-500': popped && !active,
      'border border-gray-500 -mb-px text-gray-900': popped && active,
      'text-black': !bright && !popped && active,
      'text-gray-700': !bright && !popped && !active
    }"
    @click="emitInput"
  >
    <div class="p-2 text-sm tracking-widest z-10">
      <slot></slot>
    </div>
    <div
      class="mb-1 mx-8 border-b border-b-2"
      :class="{
        'border-gray-800': !bright,
      }"
      v-if="!popped && active"
    />
  </div>
</template>

<script>
export default {
  name: "Tab",
  data() {
    return {};
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    bright: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    popped: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  methods: {
    emitInput() {
      this.$emit("input");
    }
  },
  computed: {},
  created() {}
};
</script>
